export default {
  cursor_x: 0
}
